import React from "react";
import { FormattedNumber } from "react-intl";

const Currency = ({ value }) => {
  return (
    <FormattedNumber
      minimumFractionDigits={2}
      value={value}
      // eslint-disable-next-line react/style-prop-object
      style="currency"
      currency={"EUR"}
    />
  );
};

export default Currency;
